import React from 'react'

export default function Privacy() {
  return (
    <main className='container px-6 h-screen xl:snap-start'>
      <h1 className='text-6xl font-bold py-8 pt-28'>Privacy policy</h1>
      <p className='text-2xl py-4'>We take privacy very seriously. <br/><br/>The Remify app does not collect any information at all. <br/><br/>All the data is stored locally on the user's device, which can be either erased from the Settings page in the app or it can be cleared from the system settings.</p>
    </main>
  )
}
